<script setup lang="ts">
import FormCategoriaProduto from '../components/form-categoriaproduto.vue'
import { useCategoriaProdutoStore } from '../store/useCategoriaProdutoStore'

definePage({
  meta: {
    navActiveLink: 'admin-categoria-produto',
    action: 'create',
    subject: 'categoria-produto',
  },
})

const { resetForm } = useCategoriaProdutoStore()

onBeforeRouteLeave(() => {
  resetForm()
})
</script>

<template>
  <FormCategoriaProduto />
</template>
